var Quest = new Class({
  Implements: [Options, Events],

  options: {
    cls: "w_quest",
    submit_delay: 50,
    basic_form: false,
    rangeslider_type: 'horisontal',
    query_params: '&ajax=1&counter_only=true',
    reset_initialy: false,
		type: null
  },

  initialize: function(element, options) {
    this.setOptions(options);
    this._element = element;

    if(this._element) {
      this.build();
    }
  },

  build: function(){
    var _self = this._element,
        opts = this.options,
        cls = opts.cls;
    this._form = _self.getElement('form') || _self;

    this._form_results = _self.getElement('.'+cls+'_results') || new Element('div');
    this._form_matches = _self.getElement('.'+cls+'_results_matches') || new Element('div');

    (_self.getElement('.'+cls+'_results_view a') || new Element('a')).addEvent('click', function(e){
      if(e && e.stop) e.stop();

      if(this._form.hasClass('has_results')){
        this._form.submit();
      }
    }.bind(this));

    var _results = _self.getElement('.w_quest_results');

    if(_results){
      _results.addEvent('click', function(e){
        if(e && e.stop) e.stop();

        if(this._form.hasClass('has_results')){
          this._form.submit();
        }

        Cookie.write('sr_lat', null);
        Cookie.write('sr_lng', null);
      }.bind(this));
    }

    _self.show();
    this._form.show();

    this.build_sliders();

    if(!opts.basic_form){
      this.build_date_switchers();
      this.build_date_pickers();
      this.build_master_slave_checkboxes();
      this.build_tabs();
    }

    this.add_events_to_other_form_elements();

    this.built = true;
    this.first_load = true;
    this.submit();

    var _submit = this._form.getElement('input[type=submit]');

    _submit.removeEvents();

    this._form.removeEvents();

    _submit.addEvent('click', function(e){
      e.stop();

      if(this._form.hasClass('has_results')){
        this._form.submit();
      }

      Cookie.write('sr_lat', null);
      Cookie.write('sr_lng', null);
    }.bind(this));

    if(this.options.reset_initialy){
      this._form.getElements('input[type="checkbox"]').each(function(_el){
        _el.checked = false;

        var _monitor = _el.getNext('.monitor');

        if(_monitor){
          _monitor.removeClass('_checked');
        }
      });
    }
  },

  build_date_switchers: function(){
    var _self = this._element,

        _switch_to_date_range = _self.getElement('.switch_to_date_range'),
        _switch_to_date_updated = _self.getElement('.switch_to_date_updated'),
        _date_updated_li = _self.getElement('li.date_updated_li'),

        _date_from_li = _self.getElement('li.date_from_li'),
        _date_to_li = _self.getElement('li.date_to_li'),

        _date_range_li = _date_from_li.getParent('li'),

        _dummy_input = new Element('input'),

        _date_updated_input = _date_updated_li.getElement('select') || _dummy_input,
        _date_from_input = _date_from_li.getElement('input') || _dummy_input,
        _date_to_input = _date_to_li.getElement('input') || _dummy_input;

        _date_updated_input.set('data-name', _date_updated_input.get('name'));
        _date_from_input.set('data-name', _date_from_input.get('name'));
        _date_to_input.set('data-name', _date_to_input.get('name'));

    if( _date_updated_li
        && _switch_to_date_updated
        && _switch_to_date_range
        && _date_from_li
        && _date_to_li){

      var _select = _date_updated_li.getElement('.w_styled_select ul');

      if(_select){
        _select.adopt(new Element('li').adopt(_switch_to_date_range));
      }

      _switch_to_date_updated.addEvent('click', function(e){
        if( e && e.stop) e.stop();
        _date_updated_li.show();

        _date_range_li.hide();

        // not letting the hidden fields spoil the POST object
        _date_updated_input.set('name', _date_updated_input.get('data-name'));
        _date_from_input.erase('name');
        _date_to_input.erase('name');

        Cookie.write('cr_date', 'date_listed');

        if(_date_updated_input.getParent('.additional_filters')){
          _date_updated_input.getParent('.additional_filters').removeClass('_with_date');
        }

        this.submit();
      }.bind(this));

      _switch_to_date_range.addEvent('click', function(e){
        if( e && e.stop) e.stop();

        _date_range_li.show();

        _date_updated_li.hide();

        // not letting the hidden fields spoil the POST object
        _date_updated_input.erase('name');
        _date_from_input.set('name', _date_from_input.get('data-name'));
        _date_to_input.set('name', _date_to_input.get('data-name'));

        Cookie.write('cr_date', 'date_range');

        this.submit();
      }.bind(this));


      var date_cookie = Cookie.read('cr_date');

      if(date_cookie == 'date_range'){
        _switch_to_date_range.fireEvent('click');
      }else{
        _switch_to_date_updated.fireEvent('click');
      }
    }
  },

  build_master_slave_checkboxes: function(){
    var _cf = this._element.getElements('.w_tabset .checkbox_fieldset');

    _cf.each(function(_hood){
      new Quest.Fieldset(_hood, this);
    }.bind(this));
  },

  build_date_pickers: function(){
		var _self = this;
    this._date_from = this._element.getElement(".FormSearchListings_date_from");
    this._date_to = this._element.getElement(".FormSearchListings_date_to");

		var min = Core.get_daterange_min_date(this.options.type);
		var max = Core.get_daterange_max_date();

    if (this._date_from) {
      this.date_from_picker = new Picker.Date(this._date_from, {
			  timePicker: true,
			  draggable: false,
				minDate: min,
				maxDate: max,
			  pickOnly: 'days',
			  pickerClass: 'datepicker_vista',
			  format: this._date_from.get('data-format') || "%m/%d/%Y",
			  useFadeInOut: true,
        // toggle: 'FormSearchListings_date_from',
				onSelect: function(dateText, input) {
					_self.date_to_picker.options.minDate = dateText.increment('day', 1);
				}
			});

      this._date_from.addEvent('change', this.submit.bind(this));
    }

    if (this._date_to) {
      this.date_to_picker = new Picker.Date(this._date_to,  {
        timePicker: true,
        draggable: false,
        pickOnly: 'days',
				minDate: min,
				maxDate: max,
        pickerClass: 'datepicker_vista',
        format: this._date_from.get('data-format') || "%m/%d/%Y",
        useFadeInOut: true,
        // toggle: 'FormSearchListings_date_to',
				onSelect: function(dateText, input) {
					_self.date_from_picker.options.maxDate = dateText.decrement('day', 1);
				}
      });

      this._date_to.addEvent('change', this.submit.bind(this));
    }
  },

  build_sliders: function(){
    var _price_slider = this._element.getElement('.price_slider');

    this.price_slider = new Rangeslider(_price_slider, {
      title: 'Price Range:',
      onComplete: this.submit.bind(this),
      type: this.options.rangeslider_type,
      reset_initialy: this.options.reset_initialy
    });
  },

  add_events_to_other_form_elements: function(){
    this.ngh_chk = this._form.getElements('select, input[type=checkbox]');
    this.ngh_chk.addEvent('change', this.submit.bind(this));

    this._text_inputs = this._form.getElements('input[type="text"].submittable');

    this._text_inputs.each(function(_el){
			_el.addEvent('keydown', this.submit.bind(this));
		}.bind(this));
  },

  check_values: function(min, max){
    min = min.toInt();
    max = max.toInt();

    return min <= max;
  },

  submit: function(){
    if(!this.submits){
      this.submits = 0;
    }

    this.submits++;

    this.fireEvent('change');

    (function(){
      this.submits--;

      if(this.submits > 0) return;

      this._form.removeClass('has_results');

      var min_price = this._form.getElement('.FormSearchListings_min_price').get('value').replace(/[^0-9]/g, "");
      var max_price = this._form.getElement('.FormSearchListings_max_price').get('value').replace(/[^0-9]/g, "");

      if(!this.check_values(min_price, max_price)){
        this.set_matches(0);
      }else{
        if(!this.built){
          return;
        }

        if(this.request && this.request.isRunning()){
          this.request.cancel();
        }

        var opts = this.options;
        var data = this._form.toQueryString().trim() + this.options.query_params;

        //keep the sorting
        var url =  opts.ajax_form_action || this._form.get('data-ajax-action') || this._form.get('data-rpc');

        if(this._sort_select && this._sort_select.getStyle('display') != 'none' && this._sort_select.getElement(':selected')){
        	var href = this._sort_select.getElement(':selected').get('data-href');
        	var param = href.split('&sort=')[1];
        	url += '&sort=' + param;
        }

        this.request =  new Request.JSON({
          url: url,
          method: opts.ajax_form_method || this._form.get('method') || 'post',
          data: data,
          onRequest: this.handle_form_request.bind(this),
          onSuccess: this.handle_form_success.bind(this),
          onFailure: this.handle_form_fail.bind(this)
        }).get();
      }

      this.fireEvent('submit');
    }.bind(this)).delay(this.options.submit_delay);
  },

  handle_form_request: function(){
    this._element.addClass('_loading');
    this.animate_results();
  },

  handle_form_success: function(data){
    this._element.removeClass('_loading');
    this.stop_animate_results();
    this.set_matches(data.results);

    if(data.results > 0){
      this._form.addClass('has_results');
    }else{
      this._form.removeClass('has_results');
    }

    this.fireEvent('setResults', [data.results]);
  },

  handle_form_fail: function(){
    this.stop_animate_results();
    this._element.removeClass('_loading');
    this.set_matches(0);
    this._form.removeClass('has_results');
  },

  stop_animate_results: function(){
    clearInterval(this.animate_interval_id);
  },

  animate_results: function(){
    this.current_animate_num = this._form_matches.get('text').toInt() || Number.random(1000, 4000);;
    this.stop_animate_results();
    this.animate_interval_id = this.run_animate_results.periodical(0, this);
  },

  run_animate_results: function(){
    var num =  Number.random(1000, 4000);
    this.current_animate_num = num;
    this.set_matches(num);
  },

  set_matches: function(matches){
    this._form_matches.set('html', (matches < 100000 ? matches : '+100000'));
  },

  build_tabs: function(){
    var _self = this._element,
        opts = this.options,
        cls = opts.cls,
        _tabs = _self.getElements('.'+cls+'_tab');
    if(_tabs.length){
      var _tabs_anchors = new Element('div', {'class': cls+'_tab_anchors'}).inject(_tabs[0], 'before');
      _tabs.each(function(_tab, i){
        var _legend = _tab.getElement('legend');
        var label = 'Tab '+i;
        if(_legend){
          label = _legend.hide().get('text');
        }
        new Element('a', {'class': cls + '_anchor', 'href': '#', 'text': label}).inject(_tabs_anchors);
      }.bind(this));
      var _anchors = _tabs_anchors.getElements('a');

      _anchors.addEvent('click', function(evt){
        if(evt && evt.stop){
           evt.stop();
        }
        var target = $(evt.target);
        var idx = _anchors.indexOf(target);
        _tabs.hide();
        _tabs[idx].show();

        _anchors.removeClass('selected');
        target.addClass('selected');
      }.bind(this));

      _anchors[0].addClass('first').fireEvent('click', {target: _anchors[0]});
    }
  }
});

Quest.Fieldset = new Class({
  Implements: [Events],

  initialize: function(element, quest){
    this.quest = quest;
    this._element = element;

    if(this._element){
      this.build();
    }
  },

  build: function(){
    var _self = this._element;

    this._master = _self.getElement('.master');
    this._slaves = _self.getElements('.slave');

    if(this._master && this._slaves){
      if(this._master.hasClass('w_styled_checkbox')){
        this.styled = true;
      }

      if(!this.styled){
        this._master = _self.getElement('.master input');
        this._slaves = _self.getElements('.slave input');
      }

      if(!this.styled){
        this._master.addEvent('change', this.handle_master_click.bind(this));
        this._slaves.addEvent('change', this.handle_slaves_click.bind(this));
      }else{
        this._master.addEvent('click', this.handle_master_click.bind(this));
        this._slaves.addEvent('click', this.handle_slaves_click.bind(this));
      }

      this.handle_slaves_click();
    }
  },

  handle_master_click: function(){
    if(!this.styled){
      this._slaves.each(function(_el){
        if(this._master.checked){
          _el.checked = true;
        }else{
          _el.checked = false;
        }
      }.bind(this));

      this.fireEvent('change', this);
    }else{
      (function(){
        var _master_input = this._master.getElement('input');

        if(_master_input.checked){
          this._slaves.each(function(_el){
            _el.getElement('input').checked = true;
            _el.getElement('.monitor').addClass('_checked');
          });
        }else{
          this._slaves.each(function(_el){
            _el.getElement('input').checked = false;
            _el.getElement('.monitor').removeClass('_checked');
          });
        }

        this.fireEvent('change', this);
      }.bind(this)).delay((Core.is_ie8())? 50 : 0);
    }

  },

  handle_slaves_click: function(){
    var checked = 0;

    (function(){
      this._slaves.each(function(_el){
        var _slave = this.styled? _el.getElement('input') : _el;

        if(_slave.checked){
          checked++;
        }
      }.bind(this));

      var old_value;
      var new_value;

      if(this.styled){
        var _master_input = this._master.getElement('input');

        old_value = _master_input.checked;

        if(checked == this._slaves.length){
          _master_input.checked = true;
          this._master.getElement('.monitor').addClass('_checked');
        }else{
          _master_input.checked = false;

          this._master.getElement('.monitor').removeClass('_checked');
        }

        new_value = _master_input.checked;
      }else{
        old_value = this._master.checked;
        this._master.checked = (checked == this._slaves.length);

        new_value = this._master.checked;
      }

      if(old_value != new_value){
        this.fireEvent('change', this);
      }
    }.bind(this)).delay((Core.is_ie8())? 50 : 0);
  }
});
